import { ScrollReveal } from '@/components/ui/ScrollReveal';
import { Instagram } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const InstagramFeed = () => {
  const { t } = useTranslation('home');
  // Immagini per il feed Instagram (prime 8 dalla gallery)
  const instagramImages = [
    '/img/DSC03172.JPG',
    '/img/DSC03238.JPG',
    '/img/DSC03287.JPG',
    '/img/DSC09135 (2024-04-22T17_53_48.520).JPG',
    '/img/DSC09190 (2024-04-22T17_54_40.682).JPG',
    '/img/DSC09226 (2024-04-22T17_54_53.375).JPG',
    '/img/DSC09236 (2024-04-22T17_55_00.114).JPG',
    '/img/DSC09243 (2024-04-22T17_55_05.360).JPG',
  ];

  return (
    <section className="bg-secondary py-32 px-6" aria-labelledby="instagram-heading">
      <div className="mx-auto max-w-7xl">
        <ScrollReveal>
          <div className="mb-16 text-center">
            <span className="mb-4 inline-block text-sm font-light uppercase tracking-[0.3em] text-accent">
              {t('instagram.label')}
            </span>
            <h2 id="instagram-heading" className="text-4xl font-semibold text-secondary-foreground md:text-5xl">
              {t('instagram.title')}
            </h2>
            <p className="mt-4 text-accent/80">{t('instagram.subtitle')}</p>
          </div>
        </ScrollReveal>

        {/* Instagram Feed Grid */}
        <ScrollReveal delay={100}>
          <div className="flex justify-center">
            <div className="w-full max-w-6xl">
              <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
                {instagramImages.map((image, index) => (
                  <a
                    key={index}
                    href="https://www.instagram.com/braceesapori/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative aspect-square overflow-hidden rounded-lg transition-transform hover:scale-105"
                    aria-label={t('instagram.postAria', { n: index + 1 })}
                  >
                    <img
                      src={image}
                      alt=""
                      className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
                      loading={index < 4 ? 'eager' : 'lazy'}
                      decoding="async"
                      width="400"
                      height="400"
                    />
                    {/* Overlay con icona Instagram al hover */}
                    <div className="absolute inset-0 flex items-center justify-center bg-black/0 transition-colors group-hover:bg-black/40">
                      <Instagram className="h-10 w-10 text-white opacity-0 transition-opacity group-hover:opacity-100" />
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </ScrollReveal>

        {/* Link diretto al profilo Instagram */}
        <ScrollReveal delay={200}>
          <div className="mt-8 text-center">
            <a
              href="https://www.instagram.com/braceesapori/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-accent hover:text-accent/80 transition-colors"
              aria-label={t('instagram.profileAria')}
            >
              <Instagram className="h-5 w-5" aria-hidden="true" />
              <span className="text-sm font-light uppercase tracking-wider">{t('instagram.visitProfile')}</span>
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

